import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

const fieldLabel = "text-xs font-mono uppercase tracking-[0.15em] text-slate-700 font-medium";
const inputCls = "mt-2 rounded-none border-slate-300";

/** Step 5 — contact info plus the terms/confirmation checkboxes required to submit. */
export function ConfirmStep({ form }) {
  const { contact, setContact, terms, setTerms, confirm, setConfirm } = form;
  return (
    <div data-testid="step-confirm" className="space-y-6 fade-up">
      <h2 className="font-display text-3xl tracking-tight">Your contact information</h2>
      <div className="grid sm:grid-cols-2 gap-4">
        <div><Label className={fieldLabel}>Full name</Label><Input data-testid="contact-name" value={contact.name} onChange={(e) => setContact({ ...contact, name: e.target.value })} className={inputCls} /></div>
        <div><Label className={fieldLabel}>Phone</Label><Input data-testid="contact-phone" value={contact.phone} onChange={(e) => setContact({ ...contact, phone: e.target.value })} className={inputCls} /></div>
      </div>
      <div><Label className={fieldLabel}>Email</Label><Input data-testid="contact-email" type="email" value={contact.email} onChange={(e) => setContact({ ...contact, email: e.target.value })} className={inputCls} /></div>
      <div><Label className={fieldLabel}>Brokerage or company <span className="normal-case tracking-normal text-slate-400">(optional)</span></Label><Input data-testid="contact-company" value={contact.company} onChange={(e) => setContact({ ...contact, company: e.target.value })} className={inputCls} /></div>

      <div className="space-y-3 pt-2">
        <label className="flex items-start gap-3 cursor-pointer">
          <Checkbox data-testid="terms-checkbox" checked={terms} onCheckedChange={setTerms} className="mt-0.5 rounded-none" />
          <span className="text-sm text-slate-600">I agree to Mandalay Media's <span className="underline">Terms &amp; Conditions</span> and cancellation policy.</span>
        </label>
        <label className="flex items-start gap-3 cursor-pointer">
          <Checkbox data-testid="confirm-checkbox" checked={confirm} onCheckedChange={setConfirm} className="mt-0.5 rounded-none" />
          <span className="text-sm text-slate-600">I confirm the property address, services and schedule above are correct.</span>
        </label>
      </div>
    </div>
  );
}
